import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { employeesCanCreateClientOptions, MESSAGES } from '../../const';
import { i18n } from '../../i18n';
import { Select } from '../select';
import { enqueueSnackbar } from '../snackbar';
import { useUpdateYardEmployeeMutation } from '../../hooks';

export const employeeEditModal: any = {};

export const EmployeeEditModal = () => {
  const { mutate } = useUpdateYardEmployeeMutation();
  const [open, setOpen] = useState(false);
  const [canCreateClient, setCanCreateClient] = useState(false);

  useEffect(() => {
    employeeEditModal.open = () => {
      const employee = employeeEditModal.employee || {};

      setCanCreateClient(employee.canCreateClient || false);

      employeeEditModal.isSubmitClicked = false;
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(employeeEditModal).forEach((key) => {
      if (key !== 'open') delete employeeEditModal[key];
    });
    setOpen(false);
  };

  const handleSubmitClick = () => {
    employeeEditModal.isSubmitClicked = true;

    mutate(
      { userId: employeeEditModal.id, canCreateClient },
      {
        onSuccess: () => {
          employeeEditModal.submitClick();
          handleOnClose();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.EMPLOYEE.ERROR.NOT_CREATED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'employee-edit-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.employeeEditTitle')}:{' '}
          {`${employeeEditModal.employee?.user?.firstName} ${employeeEditModal.employee?.user?.lastName}`}
        </Typography>
        <Select
          label={i18n.t('label.canCreateClient')}
          options={employeesCanCreateClientOptions}
          value={canCreateClient}
          onChange={(e) => setCanCreateClient(e.target.value)}
        />
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.edit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
